<template>
  <div class="background">
    <div> <!-- try container for 4k --> <!-- row helps to bring the sign in up -->
      <!--Tablet and Laptop Background Image-->
      <img class="row max-w-md log-in-img" src="@/assets/img/Login – 3.png" style="width: 60%;
        max-height: 100vh;
        overflow:hidden;
        position:absolute;
        top: 0px;
        opacity:100%;" />

      <!--Mobile Logo Image-->
      <img class="img-logo" src="@/assets/img/afesnew.png" />

      <!--Welcome Texts-->
      <div class="align-screen">
        <p class="welcome-text"> Welcome <br /> back! </p>

        <p class="sign-text">
          You can sign in to access
          <br />
          with your existing account
        </p>
      </div>

      <div>
        <Login></Login>

      </div>
    </div>
  </div>

</template>
<script>
import { BaseNav } from "src/components";
import { ZoomCenterTransition } from "vue2-transitions";
import Login from "./NewLogin2";
import { Divider } from "element-ui";

export default {
  components: {
    Login,
    BaseNav,
    ZoomCenterTransition,
    [Divider.name]: Divider,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      buildres: "",
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
      maindiv: "width: 100%; background-color: #ffffff"

    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.maindiv = "width: 100%; background-color: #ffffff"
        return true;
      } else {
        this.maindiv = "width: 100.8%; background-color: #ffffff"
        return false;
      }
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  mounted() {
    this.setPageClass();
  },
  created() {
    this.buildres = process.env.VUE_APP_BUILD_RES;
  },
  watch: {
    $route() {
      this.setPageClass();
    },
  },
};
</script>

<style lang="scss">
.navbar.auth-navbar {
  top: 0;
}

$scaleSize: 0.8;

@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.custom-login-background {
  background-size: cover;
  // background: require('../public/img/Login.png') no-repeat;
  // background-size: 100%;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  margin-left: 0;
  width: 60%;
  border-top: 5px solid #ffffff;
  opacity: 0.5;
}

.stack {
  padding: 10px;
}



/////////////////////

/*mobile small*/

.background {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: absolute;

}

.welcome-text {
  color: #20295c;
  font-weight: 600;
  font-size: 6vw;
  text-align: center;
  white-space: nowrap;
}

.sign-text {
  color: #20295c;
  font-size: 4vw;
  text-align: center;
}

.log-in-img {
  display: none;
}

.img-logo {
  display: block;
  width: 100px;
  margin-left: 31%;
  margin-top: 3%;
}

///////////////////////

/* mobile medium */

@media(min-width: 321px) {
  .welcome-text {
    font-size: 6vw;
  }

  .sign-text {
    color: #20295c;
    font-size: 13px;
    text-align: center;
  }

  .img-logo {
    display: block;
    width: 102px;
    margin-left: 33%;
  }

}

///////////////////////

/* mobile large */

@media(min-width: 376px) {
  .welcome-text {
    font-size: 6vw;
  }

  .sign-text {
    color: #20295c;
    font-size: 14px;
    text-align: center;
  }

  .img-logo {
    display: block;
    width: 104px;
    margin-left: 35%;
  }

}

///////////////////

/* tablet */

@media (min-width: 426px) {

  .background {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: absolute;

  }

  .welcome-text {
    font-size: 5vw;
    font-weight: 600;
    color: #1b2c5d;
    text-align: left;
    margin-left: 15%;
    margin-top: 20%;
  }

  .sign-text {
    font-size: 2vw;
    color: #1b2c5d;
    margin-left: 15%;
    text-align: left;
    white-space: nowrap;
  }

  .log-in-img {
    display: block;
  }

  .img-logo {
    display: none;
  }


  .align-screen {
    float: left;
    position: relative;
  }

}

///////////////////

/* laptop */

@media (min-width: 769px) {

  .welcome-text {
    font-size: 5vw;
    margin-top: 15%;
  }

  .sign-text {
    font-size: 2vw;

  }



}

////////////////////////

/* laptop l*/

@media (min-width: 1025px) {

  .welcome-text {
    font-size: 5vw;

  }

  .sign-text {
    font-size: 2vw;
  }

}

///////////////////

/* 4k */

@media(min-width: 1441px) {}
</style>
